import { Select } from "@fluentui/react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePaymentPlanPageStore } from "store/PaymentPlanPageStore";

type Props = {
  name: string;
  required?: boolean;
  disabled?: boolean;
  visible?: boolean;
  isLoading: boolean;
  onBlur?: (e: any) => void;
};

export const SearchDateFilterField = ({
  name,
  required = false,
  disabled = false,
  visible,
  isLoading,
  onBlur = null,
}: Props) => {
  const { t } = useTranslation();
  const [{ searchDateFilterField }, { setPaymentPlanStoreValue }] =
    usePaymentPlanPageStore();

  if (!visible) return null;
  return (
    <>
      <Select
        data-help="payment-plans-date-field"
        style={{ width: 200 }}
        required={required}
        disabled={disabled || isLoading}
        id={name}
        name={"searchDateFilterField"}
        onBlur={(e) => {
          onBlur && onBlur(e);
        }}
        onChange={(e, data) => {
          setPaymentPlanStoreValue("searchDateFilterField", data.value);
        }}
        value={searchDateFilterField || ""}
        title={t("pct.taxonomy.selectTitle.label")}
      >
        <option key={"bookingDate"} value={"bookingDate"}>
          {t("pct.bookingDate.label")}
        </option>
        <option key={"insurerReportDate"} value={"insurerReportDate"}>
          {t("pct.insurerReportDate.label")}
        </option>
        <option key={"paymentDate"} value={"paymentDate"}>
          {t("pct.paymentDate.label")}
        </option>
      </Select>
    </>
  );
};

export default SearchDateFilterField;
